<template>
    <home-franchise-hub v-if="showFranchiseHub"></home-franchise-hub>
    <home-corporate v-else-if="onCorporate()"></home-corporate>
    <home-group v-else></home-group>
</template>

<script lang="ts" setup>
import { computed, inject } from 'vue';
import HomeCorporate from './HomeCorporate.vue';
import HomeGroup from './HomeGroup.vue';
import HomeFranchiseHub from './franchise-hub/HomeFranchiseHub.vue';
import { useCurrentGroup } from '~/composables/useCurrentGroup';
import type { Features } from '~/provides/features.types';

const FEATURES = inject('FEATURES') as Features;

const { onCorporate } = useCurrentGroup();

const showFranchiseHub = computed(
    () =>
        FEATURES.contact_groups &&
        FEATURES.franchise_hub_dashboard &&
        onCorporate() &&
        (Spark.isAdminOrOwner || Spark.isPlatformAdmin)
);
</script>
